import React from "react"

function SvgComponent(props) {
  return (
    <svg
      id="prefix__Capa_1"
      data-name="Capa 1"
      viewBox="0 0 512 512"
      {...props}
    >
      <defs>
        <style>{".prefix__cls-1{fill:#283f71}"}</style>
      </defs>
      <title>{"icons"}</title>
      <path
        className="prefix__cls-1"
        d="M256.23 510.69A254.91 254.91 0 0176 75.52 254.92 254.92 0 11436.48 436a253.23 253.23 0 01-180.25 74.69zm0-501.83a246.91 246.91 0 00-174.6 421.51 246.92 246.92 0 10349.2-349.19 245.31 245.31 0 00-174.6-72.32z"
      />
      <path
        className="prefix__cls-1"
        d="M280.47 84.35a4 4 0 01-4-4v-1.63a23 23 0 00-46 0v1.63a4 4 0 01-8 0v-1.63a31 31 0 0162 0v1.63a4 4 0 01-4 4z"
      />
      <path
        className="prefix__cls-1"
        d="M297.07 158.45a13.76 13.76 0 01-13.61-11.95l-.16-1.21a30.05 30.05 0 00-59.6 0l-.16 1.21a13.77 13.77 0 01-13.62 11.95H206a13.74 13.74 0 01-13.72-13.73V87.86a11.52 11.52 0 0111.51-11.51h95.48a11.52 11.52 0 0111.53 11.51v56.86a13.75 13.75 0 01-13.73 13.73zm-43.57-47.33a38.15 38.15 0 0137.73 33.14l.16 1.2a5.73 5.73 0 0011.41-.74V87.86a3.51 3.51 0 00-3.51-3.51h-95.48a3.51 3.51 0 00-3.51 3.51v56.86a5.73 5.73 0 005.72 5.73h3.9a5.75 5.75 0 005.69-5l.15-1.2a38.17 38.17 0 0137.74-33.13zM420.56 449.4a4 4 0 01-4-4V112.06a5 5 0 00-5-5h-84.09a4 4 0 010-8h84.13a13 13 0 0113 13V445.4a4 4 0 01-4.04 4zM86.44 444.51a4 4 0 01-4-4V112.06a13 13 0 0113-13h80.23a4 4 0 010 8H95.4a5 5 0 00-5 5v328.45a4 4 0 01-3.96 4zM289.38 281.05c-.75-3.58-3.1-6.29-6-6.92l-13.64-3s-7.48 7.13-16.22 8.31c-8.74-1.18-16.22-8.31-16.22-8.31l-13.65 3c-2.91.63-5.26 3.34-6 6.92l-3 14.18h77.71zM270.72 249.7c0 10.31-7.71 18.66-17.22 18.66s-17.23-8.36-17.23-18.66S244 231 253.5 231s17.22 8.4 17.22 18.7z"
      />
      <path
        className="prefix__cls-1"
        d="M310.8 312.66H196.2v-114.6h114.6zm-106.6-8h98.6v-98.6h-98.6zM364.1 357.16H142.9a4 4 0 010-8h221.2a4 4 0 010 8zM364.1 406H142.9a4 4 0 110-8h221.2a4 4 0 010 8zM364.1 454.8H142.9a4 4 0 010-8h221.2a4 4 0 010 8z"
      />
    </svg>
  )
}

export default SvgComponent
